import { render } from "./ProdMenu.vue?vue&type=template&id=94c2294e&scoped=true"
import script from "./ProdMenu.vue?vue&type=script&lang=js"
export * from "./ProdMenu.vue?vue&type=script&lang=js"

import "./ProdMenu.vue?vue&type=style&index=0&id=94c2294e&lang=scss&scoped=true"
import "./ProdMenu.vue?vue&type=style&index=1&id=94c2294e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94c2294e"]])

export default __exports__